module.exports = __webpack_public_path__ + "static/media/Business Man.3531a2be.jpg";